<template>
  <div>
    <page-header
      title="Import from File"
      breadcrumb="Accounting > Chart of Accounts"
    />
    <div class="bg-white p-3">
      <p
        class="border-b-2 border-gray-200 py-2 flex justify-between items-center"
      >
        <span>Import {{ this.$route.params.id == 'sales' ? 'Sales' : 'Purchase' }} Data </span>
        <img src="@/assets/images/icons/info.svg" alt="information icon" />
      </p>
      <p class="text-sm py-3">
        Use this contacts CSV template here as a guide in creating your csv file
        to upload your external purchase data.
      </p>

      <div class="flex justify-center relative bg-gray-200 py-20">
        <button class="absolute bottom">Clear Upload</button>
        <div class="w-auto">
          <div class="flex items-center border-2 border-gray-500">
            <input type="file" class="ml-1" /><button
              class="px-3 py-2 bg-primary-navy text-white"
            >
              Choose File
            </button>
          </div>
          <small>*Select a .CSV file</small>

          <p class="w-full flex justify-center mt-5">
            <button class="py-2 px-3 bg-primary-yellow">Upload</button>
          </p>
        </div>
      </div>

      <component :is="currentPage"/>
      <EmptyImportFile  v-show="false" />
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/UI/NewPageHeader";
import ImportFileCost from "@/components/3pl/Accounting/Cost/modules/ImportFileCost.vue";
import ImportFileSales from "@/components/3pl/Accounting/Sales/modules/ImportFileSales.vue";
import EmptyImportFile from "@/components/3pl/Accounting/Sales/modules/EmptyImportFile.vue";

export default {
  components: { PageHeader, ImportFileCost, ImportFileSales, EmptyImportFile },
  computed: {
    currentPage() {
      let screen = "";
      switch (this.$route.params.id) {
        case "cost":
          screen = "import-file-cost";
          break;
        case "sales":
          screen = "import-file-sales";
          break;
      }
      return screen;
    },
  },
};
</script>

<style lang="scss" scoped>
.bottom {
  right: 15px;
  bottom: 10px;
  opacity: 0.5;
}
</style>
